/* global window */

import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout } from 'common/components/layout';
import { getReservationType } from 'redux/reservationTypes/actions';
import { getReservationTypeBySlug } from 'redux/reservationTypes/reducers';
import AvailabilityForReservationType from 'reservations/availability/AvailabilityForReservationType';

import Image from './components/Image';

class ReservationType extends Component {
  componentDidMount() {
    const { props } = this;
    const { slug } = props.match.params;
    props.getReservationType(slug);
    try {
      window.scrollTo({ top: 0 });
    } catch {
      // Not all browsers have scrollTo
    }
  }

  render() {
    const { settings, reservationType, reservationTypeReducer, match } =
      this.props;
    if (
      !settings.data ||
      (!reservationType && reservationTypeReducer.isFetching)
    ) {
      return (
        <Layout title="" loading>
          &nbsp;
        </Layout>
      );
    }
    if (!reservationType && !reservationTypeReducer.isFetching) {
      return (
        <Layout title="" loading>
          Reservation Type not found
        </Layout>
      );
    }
    const { slug } = match.params;
    return (
      <Layout
        title={reservationType.seo.title}
        description={reservationType.seo.description}
      >
        <div className="c7-experience">
          <Image reservationType={reservationType} />
          <div className="c7-experience__content">
            <h2>{reservationType.title}</h2>
            <div
              dangerouslySetInnerHTML={{ __html: reservationType.content }}
            />
          </div>
        </div>
        <AvailabilityForReservationType
          reservationTypeSlug={slug}
          form={slug}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  reservationType: getReservationTypeBySlug(
    state.reservationType,
    ownProps.match.params.slug
  ),
  reservationTypeReducer: state.reservationType,
  settings: state.setting
});

export default connect(mapStateToProps, {
  getReservationType
})(ReservationType);
